/*
 *
 * actions
 *
 */

import {
    LOAD_LEAVE_DETAILS,
    LOAD_LEAVE_DETAILS_SUCCESS,
    LOAD_LEAVE_DETAILS_ERROR,
    LOAD_PERMISSION,
    LOAD_LEAVE_PERMISSION_SUCCESS,
    LOAD_LEAVE_PERMISSION_ERROR,
    LOAD_LOP,
    LOAD_LOP_SUCCESS,
    LOAD_LOP_ERROR,
    //LOAD_DROPDOWN_LEAVE_LEAVE
    LOAD_DROPDOWN_LEAVE,
    LOAD_DROPDOWN_LEAVE_SUCCESS,
    LOAD_DROPDOWN_LEAVE_ERROR,
    LOAD_SETTING,
    LOAD_SETTING_SUCCESS,
    LOAD_SETTING_ERROR
} from "./constants";

//leave details
export function loadLeaveDetails(searchFilter) {
    return {
        type: LOAD_LEAVE_DETAILS,
        searchFilter
    }
}

export function loadLeaveDetailsSuccess(leaveList, success) {
    return {
        type: LOAD_LEAVE_DETAILS_SUCCESS,
        leaveList,
        success,
    }
}

export function loadLeaveDetailsError(error) {
    return {
        type: LOAD_LEAVE_DETAILS_ERROR,
        error
    }
}

//permission

export function loadPermission(searchFilter) {
    return {
        type: LOAD_PERMISSION,
        searchFilter
    }
}

export function loadPermissionSuccess(permissionList,success){
    return{
        type:LOAD_LEAVE_PERMISSION_SUCCESS,
        permissionList,
        success,
    }
}

export function loadPermissionError(error) {
    return {
        type: LOAD_LEAVE_PERMISSION_ERROR,
        error
    }
}

//LOP

export function loadLOP(searchFilter) {
    return {
        type: LOAD_LOP,
        searchFilter
    }
}

export function loadLOPSuccess(lopList, success) {
    return {
        type: LOAD_LOP_SUCCESS,
        lopList,
        success,
    }
}

export function loadLOPError(error) {
    return {
        type: LOAD_LOP_ERROR,
        error
    }
}

// EMPLOYEE DEFAULT DROPDOWN

export function loadSetting(searchFilter) {
    return {
        type: LOAD_SETTING,
        searchFilter
    }
}

export function loadSettingSuccess(settingList, success) {
    return {
        type: LOAD_SETTING_SUCCESS,
        settingList,
        success,
    }
}

export function loadSettingError(error) {
    return {
        type: LOAD_SETTING_ERROR,
        error
    }
}
// DROPDOWN  loadLeaveDropdown
export function loadLeaveDropdown(searchFilter) {
    return {
        type: LOAD_DROPDOWN_LEAVE,
        searchFilter,
    };
}

export function loadLeaveDropdownSuccess(dropDownList, success) {
    return {
        type: LOAD_DROPDOWN_LEAVE_SUCCESS,
        dropDownList,
        success,
    };
}

export function loadLeaveDropdownError(error) {
    return {
        type: LOAD_DROPDOWN_LEAVE_ERROR,
        error,
    };
}